export function mergeHydratedRosterComments(serverComments = [], localComments = [], requestStartedAt = new Date(), targetDojoId = null) {
  const startedAt = new Date(requestStartedAt).getTime();
  const liveAfterRequest = (localComments || []).filter(comment => (
    new Date(comment?._received_at || comment?.created_at || 0).getTime() >= startedAt
    && (targetDojoId === null || (String(targetDojoId) && String(comment?._dojo_id || '') === String(targetDojoId)))
  ));
  return selectRosterCoachComments([...liveAfterRequest, ...(serverComments || [])]);
}

export function selectRosterCoachComments(comments = [], limit = null) {
  const seen = new Set();
  const selected = [...(comments || [])]
    .filter(comment => comment && String(comment.text || '').trim())
    .sort((a, b) => new Date(b._received_at || b.created_at || 0) - new Date(a._received_at || a.created_at || 0))
    .filter(comment => {
      const key = String(comment._id || `${comment.activity_id}:${comment.text}`);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  if (limit === null || limit === undefined) return selected;
  return selected.slice(0, Math.max(0, Number(limit) || 0));
}
